export default "__VITE_ASSET__76a9a6c2__"